import { UserActions } from './types';
export const subscribe = ({ uuid, userId, state }) => async (dispatch) => {
    const payload = {
        state,
        uuid,
        userId,
    };
    dispatch({
        type: UserActions.STATE_UPDATE,
        payload,
    });
};
export const reset = () => async (dispatch) => {
    dispatch({
        type: UserActions.STATE_RESET,
    });
};
